export default { 
  h3dfabd41078e23fb0dff3acb5eac97d3: [[({}, [C0, C1]) => [C0(), C1()], {}]] 
}